import cx from 'classnames'
import React from 'react'
import { connect } from 'react-redux'

import './ProjectInformation.css'

const Shortcuts = (props) => (
  <div className="Modal-product-information-shortcuts">
    {props.shortcuts.map(({ name, combinations, soon }) => (
      <div className={cx('item', { soon })} key={name}>
        <span>{name}</span>

        <div className="item-combinations">
          {combinations.map((key, idx) => (
            <React.Fragment key={key}>
              <div>
                {key === 'meta' && (
                  <>
                    Ctrl
                    <span>/</span>
                    <svg
                      width="12"
                      height="13"
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.0026 0.833496C3.70985 0.833496 4.38813 1.11445 4.88822 1.61454C5.38832 2.11464 5.66927 2.79292 5.66927 3.50016V4.8335H8.33594V3.50016C8.33594 2.79292 8.61689 2.11464 9.11699 1.61454C9.61708 1.11445 10.2954 0.833496 11.0026 0.833496C11.7098 0.833496 12.3881 1.11445 12.8882 1.61454C13.3883 2.11464 13.6693 2.79292 13.6693 3.50016C13.6693 4.20741 13.3883 4.88568 12.8882 5.38578C12.3881 5.88588 11.7098 6.16683 11.0026 6.16683H9.66927V8.8335H11.0026C11.7098 8.8335 12.3881 9.11445 12.8882 9.61454C13.3883 10.1146 13.6693 10.7929 13.6693 11.5002C13.6693 12.2074 13.3883 12.8857 12.8882 13.3858C12.3881 13.8859 11.7098 14.1668 11.0026 14.1668C10.2954 14.1668 9.61708 13.8859 9.11699 13.3858C8.61689 12.8857 8.33594 12.2074 8.33594 11.5002V10.1668H5.66927V11.5002C5.66927 12.2074 5.38832 12.8857 4.88822 13.3858C4.38813 13.8859 3.70985 14.1668 3.0026 14.1668C2.29536 14.1668 1.61708 13.8859 1.11699 13.3858C0.616889 12.8857 0.335938 12.2074 0.335938 11.5002C0.335938 10.7929 0.616889 10.1146 1.11699 9.61454C1.61708 9.11445 2.29536 8.8335 3.0026 8.8335H4.33594V6.16683H3.0026C2.29536 6.16683 1.61708 5.88588 1.11699 5.38578C0.616889 4.88568 0.335938 4.20741 0.335938 3.50016C0.335938 2.79292 0.616889 2.11464 1.11699 1.61454C1.61708 1.11445 2.29536 0.833496 3.0026 0.833496ZM9.66927 11.5002C9.66927 11.8538 9.80975 12.1929 10.0598 12.443C10.3098 12.693 10.649 12.8335 11.0026 12.8335C11.3562 12.8335 11.6954 12.693 11.9454 12.443C12.1955 12.1929 12.3359 11.8538 12.3359 11.5002C12.3359 11.1465 12.1955 10.8074 11.9454 10.5574C11.6954 10.3073 11.3562 10.1668 11.0026 10.1668H9.66927V11.5002ZM8.33594 6.16683H5.66927V8.8335H8.33594V6.16683ZM3.0026 10.1668C2.64898 10.1668 2.30984 10.3073 2.0598 10.5574C1.80975 10.8074 1.66927 11.1465 1.66927 11.5002C1.66927 11.8538 1.80975 12.1929 2.0598 12.443C2.30984 12.693 2.64898 12.8335 3.0026 12.8335C3.35623 12.8335 3.69536 12.693 3.94541 12.443C4.19546 12.1929 4.33594 11.8538 4.33594 11.5002V10.1668H3.0026ZM4.33594 3.50016C4.33594 3.14654 4.19546 2.8074 3.94541 2.55735C3.69536 2.30731 3.35623 2.16683 3.0026 2.16683C2.64898 2.16683 2.30984 2.30731 2.0598 2.55735C1.80975 2.8074 1.66927 3.14654 1.66927 3.50016C1.66927 3.85378 1.80975 4.19292 2.0598 4.44297C2.30984 4.69302 2.64898 4.8335 3.0026 4.8335H4.33594V3.50016ZM11.0026 4.8335C11.3562 4.8335 11.6954 4.69302 11.9454 4.44297C12.1955 4.19292 12.3359 3.85378 12.3359 3.50016C12.3359 3.14654 12.1955 2.8074 11.9454 2.55735C11.6954 2.30731 11.3562 2.16683 11.0026 2.16683C10.649 2.16683 10.3098 2.30731 10.0598 2.55735C9.80975 2.8074 9.66927 3.14654 9.66927 3.50016V4.8335H11.0026Z"
                        fill="#768BA7"
                      />
                    </svg>
                  </>
                )}

                {key === 'click' && (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9258 5.61914C12.3359 5.47266 12.7461 5.47266 13.1562 5.58984C13.5664 5.70703 13.8887 5.94141 14.1523 6.29297C14.416 6.64453 14.5625 7.02539 14.5625 7.46484V9.92578C14.5625 10.1016 14.5332 10.248 14.5039 10.3652L13.7129 13.8516C13.5957 14.3203 13.3613 14.6719 13.0098 14.9648C12.6582 15.2578 12.248 15.375 11.8086 15.375H6.59375C6.27148 15.375 5.97852 15.3164 5.71484 15.1699C5.42188 15.0234 5.1875 14.8184 5.01172 14.5547L1.81836 10.043C1.49609 9.63281 1.37891 9.13477 1.4668 8.60742C1.52539 8.08008 1.78906 7.64062 2.22852 7.31836C2.49219 7.14258 2.78516 7.02539 3.10742 6.9668C3.42969 6.9082 3.75195 6.9375 4.04492 7.05469V2.33789C4.04492 1.81055 4.2207 1.3418 4.60156 0.960938C4.98242 0.580078 5.45117 0.375 5.97852 0.375C6.50586 0.375 6.97461 0.580078 7.35547 0.960938C7.73633 1.3418 7.94141 1.81055 7.94141 2.33789V4.50586C8.23438 4.44727 8.52734 4.47656 8.82031 4.59375C9.11328 4.71094 9.34766 4.85742 9.58203 5.0625C9.99219 4.88672 10.4023 4.85742 10.8418 4.94531C11.2812 5.0625 11.6328 5.26758 11.9258 5.61914ZM3.81055 8.57812C3.66406 8.40234 3.48828 8.31445 3.3125 8.34375C3.10742 8.40234 2.96094 8.51953 2.87305 8.69531C2.78516 8.87109 2.81445 9.04688 2.96094 9.22266L6.1543 13.7344C6.27148 13.9102 6.41797 13.9688 6.59375 13.9688H11.8086C11.9258 13.9688 12.043 13.9395 12.1602 13.8516C12.248 13.793 12.3066 13.6758 12.3359 13.5293L13.127 10.043L13.1562 9.92578V7.46484C13.1562 7.23047 13.0684 7.08398 12.8926 6.99609C12.7168 6.9082 12.5117 6.9082 12.3359 6.99609C12.1602 7.08398 12.0723 7.23047 12.0723 7.46484C12.0723 7.61133 12.0137 7.72852 11.9258 7.81641C11.8379 7.9043 11.7207 7.93359 11.6035 7.93359H11.4277C11.2812 7.93359 11.1641 7.9043 11.0762 7.81641C10.9883 7.72852 10.959 7.61133 10.959 7.46484V6.84961C10.959 6.61523 10.8418 6.46875 10.666 6.38086C10.4902 6.29297 10.3145 6.29297 10.1387 6.38086C9.96289 6.46875 9.875 6.61523 9.875 6.84961V7.46484C9.875 7.61133 9.81641 7.72852 9.72852 7.81641C9.64062 7.9043 9.52344 7.93359 9.40625 7.93359H9.20117C9.08398 7.93359 8.9668 7.9043 8.87891 7.81641C8.76172 7.72852 8.73242 7.61133 8.73242 7.46484V6.43945C8.73242 6.20508 8.64453 6.05859 8.46875 5.9707C8.29297 5.88281 8.11719 5.88281 7.94141 5.9707C7.76562 6.05859 7.67773 6.20508 7.67773 6.43945V7.46484C7.67773 7.61133 7.61914 7.72852 7.53125 7.81641C7.41406 7.9043 7.32617 7.93359 7.20898 7.93359H7.00391C6.85742 7.93359 6.74023 7.9043 6.65234 7.81641C6.56445 7.72852 6.53516 7.61133 6.53516 7.46484V2.33789C6.53516 2.10352 6.41797 1.95703 6.24219 1.86914C6.06641 1.78125 5.89062 1.78125 5.71484 1.86914C5.53906 1.95703 5.45117 2.10352 5.45117 2.33789V9.39844C5.45117 9.63281 5.33398 9.80859 5.12891 9.86719C4.89453 9.92578 4.71875 9.86719 4.60156 9.69141L3.81055 8.57812ZM6.59375 12.0938C6.59375 12.2402 6.62305 12.3574 6.71094 12.4453C6.76953 12.5332 6.88672 12.5625 7.00391 12.5625H7.17969C7.29688 12.5625 7.38477 12.5332 7.47266 12.4453C7.53125 12.3574 7.58984 12.2402 7.58984 12.0938V9.28125C7.58984 9.16406 7.53125 9.04688 7.47266 8.95898C7.38477 8.87109 7.29688 8.8125 7.17969 8.8125H7.00391C6.88672 8.8125 6.76953 8.87109 6.71094 8.95898C6.62305 9.04688 6.59375 9.16406 6.59375 9.28125V12.0938ZM8.82031 12.0938C8.82031 12.2402 8.84961 12.3574 8.9375 12.4453C8.99609 12.5332 9.11328 12.5625 9.23047 12.5625H9.40625C9.49414 12.5625 9.58203 12.5332 9.66992 12.4453C9.75781 12.3574 9.81641 12.2402 9.81641 12.0938V9.28125C9.81641 9.16406 9.75781 9.04688 9.66992 8.95898C9.58203 8.87109 9.49414 8.8125 9.40625 8.8125H9.23047C9.11328 8.8125 8.99609 8.87109 8.9375 8.95898C8.84961 9.04688 8.82031 9.16406 8.82031 9.28125V12.0938ZM11.0176 12.0938C11.0176 12.2402 11.0469 12.3574 11.1348 12.4453C11.1934 12.5332 11.3105 12.5625 11.4277 12.5625H11.6035C11.7207 12.5625 11.8086 12.5332 11.8965 12.4453C11.9551 12.3574 12.0137 12.2402 12.0137 12.0938V9.28125C12.0137 9.16406 11.9551 9.04688 11.8965 8.95898C11.8086 8.87109 11.7207 8.8125 11.6035 8.8125H11.4277C11.3105 8.8125 11.1934 8.87109 11.1348 8.95898C11.0469 9.04688 11.0176 9.16406 11.0176 9.28125V12.0938Z"
                      fill="#768BA7"
                    />
                  </svg>
                )}

                {key !== 'meta' && key !== 'click' && key}
              </div>

              {idx !== combinations.length - 1 && (
                <div className="item-combinations-plus">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9688 5.34375C11.0391 5.34375 11.1094 5.39062 11.1562 5.4375C11.2031 5.48438 11.25 5.55469 11.25 5.625V6.375C11.25 6.46875 11.2031 6.53906 11.1562 6.58594C11.1094 6.63281 11.0391 6.65625 10.9688 6.65625H6.65625V10.9688C6.65625 11.0625 6.60938 11.1328 6.5625 11.1797C6.51562 11.2266 6.44531 11.25 6.375 11.25H5.625C5.53125 11.25 5.46094 11.2266 5.41406 11.1797C5.36719 11.1328 5.34375 11.0625 5.34375 10.9688V6.65625H1.03125C0.9375 6.65625 0.867188 6.63281 0.820312 6.58594C0.773438 6.53906 0.75 6.46875 0.75 6.375V5.625C0.75 5.55469 0.773438 5.48438 0.820312 5.4375C0.867188 5.39062 0.9375 5.34375 1.03125 5.34375H5.34375V1.03125C5.34375 0.960938 5.36719 0.890625 5.41406 0.84375C5.46094 0.796875 5.53125 0.75 5.625 0.75H6.375C6.44531 0.75 6.51562 0.796875 6.5625 0.84375C6.60938 0.890625 6.65625 0.960938 6.65625 1.03125V5.34375H10.9688Z"
                      fill="#2F7FEF"
                    />
                  </svg>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    ))}
  </div>
)

const ProductInformationModal = (props) => {
  const shortcuts = [
    {
      name: 'Copy',
      combinations: ['meta', 'C'],
      soon: false,
    },
    {
      name: 'Copy node',
      combinations: ['meta', 'Shift', 'C'],
      soon: false,
    },
    {
      name: 'Paste',
      combinations: ['meta', 'V'],
      soon: false,
    },
    {
      name: 'Duplicate',
      combinations: ['meta', 'Shift', 'D'],
      soon: false,
    },
    {
      name: 'Default tool',
      combinations: ['D'],
      soon: false,
    },
    {
      name: 'Select pages tool',
      combinations: ['S'],
      soon: false,
    },
    {
      name: 'Multiple select',
      combinations: ['Shift', 'click'],
      soon: false,
    },
    {
      name: 'Undo',
      combinations: ['meta', 'Z'],
      soon: false,
    },
    {
      name: 'Redo',
      combinations: ['meta', 'Shift', 'Z'],
      soon: false,
    },
    {
      name: 'Zoom in',
      combinations: ['meta', '+'],
      soon: false,
    },
    {
      name: 'Zoom out',
      combinations: ['meta', '-'],
      soon: false,
    },
    // {
    //   name: 'Next page',
    //   combinations: ['Tab'],
    //   soon: false,
    // },
    {
      name: 'Close window',
      combinations: ['Esc'],
      soon: false,
    },
    {
      name: 'Edit selected item',
      combinations: ['Enter'],
      soon: false,
    },
    {
      name: 'Delete item',
      combinations: ['Backspace'],
      soon: false,
    },
  ]

  return (
    <div className="Modal-product-information">
      <div className="Modal-product-information-content">
        <div className="Modal-product-information-header">
          <div className="Modal-product-information-heading">Shortcuts</div>

          {props.closeButton}
        </div>

        <div className="Modal-product-information-body">
          <Shortcuts shortcuts={shortcuts} />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({
  loggedIn: auth.authenticated,
})

export default connect(mapStateToProps)(ProductInformationModal)
